export default (el) => ({
  id: String(el.id),
  title: el.title || '',
  hallId: String(el.hall_id),
  isVirtual: Boolean(el.virtual),
  extraElements: el.extraElements || [],
  areas: el.areas || [],
  sectors: el.sectors || [],
});
